

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      width: 50,
      slot: 'index',
      align:'center'
    },
    {
      key: 'workunit',
      dataIndex: 'workunit',
      title: '单位',
      minWidth: 200,
      align:'center'
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户ID',
      align:'center'
    },
    {
      key: 'realname',
      dataIndex: 'realname',
      title: '姓名',
      align:'center'
    },
    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
      align:'center'
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '操作',
      width: 100,
      slot: 'operate',
      fixed: 'right',
      align:'center'
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
